-- | Application step identity and widget navigation.
module App.Step where

import API.Types (DocumentID)

-- | Type for attempting to display certain widgets. If we fail to display a
-- | page there should be an error widget to tell the user what went wrong.
data Step
    = Step1
    -- ^ Landing page for authenticated users. Allows selecting forms and
    -- searching through recent documents.

    | Step2A
    -- ^ Start of the form creation process. Allows selecting students.

    | Step2B
    -- ^ After selecting students, you can select a number of forms to be
    -- created for each student. This step only shows if no forms were selected
    -- in Step1.

    | Step3
    -- ^ Once students and forms have been selected, we display the forms so
    -- that they can be filled out by teacher and students.

    | Step3Doc DocumentID
    -- ^ Load a specific document directly into Step3.

    | Step4
    -- ^ Preview a student's specific form and allow relevant persons to sign
    -- documents.
    --
    -- NOTE: This constructor will likely need a reference to a specific form.

    | Preview Int
    -- ^ This allows us to preview a form for development using our Step3
    -- renderer.

    | TestForm

-- TODO: Breadcrumbs

data Navigation
    = NavNext
    -- ^ Navigate to the next step.
    | NavCancel
    -- ^ Cancel and return to the recent forms page.
    | NavJump Step
    -- ^ Jump to the given step.
